import { createTRPCReact } from '@trpc/react-query';
import type { AppRouter } from '@hello/api';

// Legacy tRPC client for existing code using `api.xxx.useQuery()` pattern
// New code should use `useTRPC` from '@/trpc/react' for server prefetching support
export const api = createTRPCReact<AppRouter>();
